import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { ProjectSettingsPopup } from './ProjectSettingsPopup';

export const PROJECT_SETTINGS_POPUP = Symbol('PROJECT_SETTINGS');

export const useProjectSettingsPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(PROJECT_SETTINGS_POPUP, ProjectSettingsPopup);
  });

  return useCallback(
    ({
      isDisplayedBeforeGoBack,
      isDocument,
      displayName,
      displayMoveToFolder,
      onConfirm,
      onCancel,
      name,
      projectFolderId,
    }) => {
      popups.openPopup(PROJECT_SETTINGS_POPUP, {
        isDisplayedBeforeGoBack,
        isDocument,
        displayName,
        displayMoveToFolder,
        name,
        projectFolderId,

        onConfirm: async (result) => {
          await onConfirm(result);
          popups.closePopup(PROJECT_SETTINGS_POPUP);
        },
        onCancel: async () => {
          if (onCancel) {
            await onCancel();
          }
          popups.closePopup(PROJECT_SETTINGS_POPUP);
        },
      });
    },
    [popups]
  );
};
